import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import DeferredDebtSummaryGDC from './DeferredDebtSummary.GDC';

const DeferredDebtSummary = () => {
  switch (portal) {
    case Portal.Gascaribe:
      return <DeferredDebtSummaryGDC />;
    default:
      return <></>;
  }
};

export default DeferredDebtSummary;
